import { render } from "./TandartsDenBosch.vue?vue&type=template&id=0e75f68c&scoped=true"
import script from "./TandartsDenBosch.vue?vue&type=script&lang=js"
export * from "./TandartsDenBosch.vue?vue&type=script&lang=js"

import "./TandartsDenBosch.vue?vue&type=style&index=0&id=0e75f68c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e75f68c"]])

export default __exports__